(() => {
  const mq = window.matchMedia('(min-width: 990px)');

  function closeAll(detailsList) {
    detailsList.forEach(d => d.removeAttribute('open'));
  }

  function init() {
    if (!mq.matches) return;

    const nav = document.querySelector('nav.header__inline-menu');
    if (!nav) return;

    // Only top-level dropdown <details> (not nested ones)
    const detailsList = Array.from(nav.querySelectorAll('details'))
      .filter(d => !d.closest('.header__submenu'));

    // Open on hover, but DO NOT close when leaving the item
    detailsList.forEach(d => {
      d.addEventListener('mouseenter', () => {
        d.setAttribute('open', '');
      });

      // Prevent Dawn’s default "close on mouseleave" if it exists
      d.addEventListener(
        'mouseleave',
        (e) => {
          // Stop other mouseleave handlers from closing it
          e.stopImmediatePropagation();
        },
        true // capture
      );
    });

    // Close everything only when leaving the whole nav area
    nav.addEventListener('mouseleave', () => closeAll(detailsList));

    // Close on outside click
    document.addEventListener('click', (e) => {
      if (!nav.contains(e.target)) closeAll(detailsList);
    });

    // Close on ESC
    document.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') closeAll(detailsList);
    });
  }

  document.addEventListener('DOMContentLoaded', init);
  mq.addEventListener?.('change', () => location.reload());
})();